//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilesService from '@/apps/data-platform/services/security/files_service';
export default {
  name: 'DisplayImage',
  data: function data() {
    return {
      uris: null,
      image: null,
      isLoading: false,
      dataImage: null,
      filename: null,
      contentType: ''
    };
  },
  created: function created() {
    var _this = this;
    // load monitoring
    var urisEncoded = this.$route.query.uris;
    this.isLoading = true;
    FilesService.readFile(urisEncoded).then(function (response) {
      if (response.code >= 200 && response.code < 300) {
        _this.image = response.data.base64;
        _this.dataImage = response.data;
        _this.filename = response.data.name.split('/').pop();
        _this.contentType = response.data.contentType;
      } else {
        _this.image = null;
        _this.dataImage = null;
        _this.filename = null;
      }
      _this.isLoading = false;
    });
  }
};